<template>
    <crud-base
      :url="url"
      :columns="columns"
      :onDelete="() => {}"
      :onUpdate="() => {}"
      :onStore="() => {}"
      :enableSearch="true"
      :checkAlerts="true"
      :formInputs="formInputs"
      primaryKey="id"
    >
      <template v-slot:modo_rateio="{model}">
        <span :class="+model.modo_rateio ? 'badge badge-success' : 'badge badge-secondary'">
          {{ labelModoRateio(model.modo_rateio) }}
        </span>
      </template>
    </crud-base>

</template>

<script>
import CrudBase from "../../../components/crud/CrudBase";
import { schemaReadOnly, schemaSelect } from "@/helpers/form";
import { get } from "@/helpers/apiRequest";

const VALOR_VENDA = 2;

const MODOS_RATEIO = {
  0: "Não rateia",
  1: "Rateia no custo",
  [VALOR_VENDA]: "Rateia no valor de venda",
};

const AJUDA_MODOS_RATEIO = [
  "<b>Não rateia:</b> o frete vai no cabeçalho do pedido e é cobrado à parte.",
  "<b>Rateia no custo:</b> o frete é distribuído no custo dos itens e afeta só a margem. O preço e o total do pedido enviados ao ERP não mudam.",
  "<b>Rateia no valor de venda:</b> o frete é embutido no preço de cada item enviado ao ERP, e o frete do cabeçalho vai zerado. O cliente vê o frete dentro do preço dos produtos.",
];

const AVISO_SEM_SUPORTE_VALOR_VENDA =
  "<b>Atenção:</b> a integração com o ERP deste ambiente não suporta o rateio no valor de venda. Um tipo de frete salvo nesse modo será recusado.";

function schemaModoRateio(suportaValorVenda) {
  const opcoes = { ...MODOS_RATEIO };
  const ajuda = [...AJUDA_MODOS_RATEIO];

  if (!suportaValorVenda) {
    opcoes[VALOR_VENDA] = `${MODOS_RATEIO[VALOR_VENDA]} (indisponível nesta integração)`;
    ajuda.push(AVISO_SEM_SUPORTE_VALOR_VENDA);
  }

  const schema = schemaSelect("Rateio de frete", true, 12, opcoes, 0, {
    description: ajuda.join("<br>"),
  });

  // A API devolve modo_rateio como número: com as opções em texto ("0"), o
  // select não acha a opção do registro e mostra o valor cru.
  schema.type = "number";
  schema.ui.widgetConfig.enumSource = schema.ui.widgetConfig.enumSource.map(
    (opcao) => ({ ...opcao, value: +opcao.value })
  );

  return schema;
}

export default {
  name: "TiposFrete",
  components: {
    CrudBase,
  },
  data() {
    return {
      url: "/admin/tipo-frete",
      columns: [
        { label: "ID", field: "id", sortable: false },
        { label: "DESCRIÇÃO", field: "descricao", sortable: false },
        { label: "ATIVO", field: "ativo", sortable: false },
        { label: "RATEIO DE FRETE", field: "modo_rateio", sortable: false, useSlot: true }
      ],
      formInputs: {
        id: schemaReadOnly("Cód.", 3),
        descricao: schemaReadOnly("Descrição", 9),
        modo_rateio: schemaModoRateio(true),
      },
    };
  },
  created() {
    this.carregarSuporteRateio();
  },
  methods: {
    async carregarSuporteRateio() {
      try {
        const suporte = await get(`${this.url}/suporte-rateio`);
        this.formInputs.modo_rateio = schemaModoRateio(!!suporte.valor_venda);
      } catch (erro) {
        // Sem a resposta, a tela segue sem o aviso; a API continua validando o modo.
        console.error("Erro ao consultar o suporte ao rateio de frete:", erro);
      }
    },
    labelModoRateio(modo) {
      return MODOS_RATEIO[+modo] ?? MODOS_RATEIO[0];
    },
  },
};
</script>
